<template>

  <div class="tabson1" >
<!--    <label >{{queryData.taxReportTime}} </label>
    <label >{{queryData.taxCompanyName}} </label>-->
<!--
    税金申报情况：<label style="color: #5daf34">{{ queryData.taxReportStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>
    <label style="color: #409EFF">&ensp;{{ queryData.taxPayStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>
-->

    <!--    <el-button type="primary" size="small" @click="backToCodeSet()" style="float: right">返回</el-button>-->

    <bsp-table
      :data.sync="list"
      ref="accountTable"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getEmpWagesList"
      :showPagination="listQuery.page"
      style="width: 100%"
    >
      <bsp-table-column  title="员工信息" :grounpColumns="grounpColumns">
      </bsp-table-column>

      <bsp-table-column  title="考勤数据" :grounpColumns="grounpColumns1">
      </bsp-table-column>
      <bsp-table-column
        field="payAmount"
        filter-type=""
        title="应发工资"
        width="10%">
        <template slot-scope="scope">{{ scope.row.payAmount }}</template>
      </bsp-table-column>
      <bsp-table-column  title="税前计税部分" :grounpColumns="grounpColumns2">
      </bsp-table-column>
      <bsp-table-column  title="税前免税部分" :grounpColumns="grounpColumns3">
      </bsp-table-column>
      <bsp-table-column  title="社保信息" :grounpColumns="grounpColumns4">
      </bsp-table-column>


    </bsp-table>


  </div>
</template>
<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getTaxList,getTaxBatchById,updateTaxBatch,getBatchEmpByIdList,getEmpDetailByIdList,getEmpWagesDetailList,getEmpWagesList} from "@/api/tax/tax";
  import {mapGetters} from 'vuex';
  export default {
    name: "tabson1",
    components: { bspTableColumn, bspTable},
    props:{
      currentTab:{
        type:String,
        default:''
      }
    },
    watch: {

    },
    created(){
      this.queryData=this.$route.query

      this._getEmpWagesList()

    },
    mounted(){

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data() {
      return {
        queryData:null,
        list:[],
        grounpColumns:[
          {
            field:"empName",
            title:"姓名",
            },
          {
            field:"idCard",
            title:"证件号码",
          }
    ],
        grounpColumns1:[
          {
            field:"",
            title:"离职时间",
          },
          {
            field:"",
            title:"事假扣款",
          },
          {
            field:"",
            title:"加班小时",
          },
          {
            field:"",
            title:"加班工资",
          },
          {
            field:"",
            title:"日工资",
          },
          {
            field:"",
            title:"病假小时",
          }

        ],
        grounpColumns2:[
          {
            field:"commercialInsuranceTax",
            title:"税前商保计税部分",
          },
          {
            field:"otherTax",
            title:"税前其他计税部分",
          },
          {
            field:"fundCompanyTax",
            title:"公积金单位计税部分",
          }


        ],
        grounpColumns3:[
          {
            field:"donationFree",
            title:"税前捐赠免税部分",
          },
          {
            field:"otherFree",
            title:"税前其他免税部分",
          },
          {
            field:"enterpriseAnnuityFree",
            title:"企业年金",
          }
        ],
        grounpColumns4:[
          {
            field:"endowmentIndv",
            title:"养老",
          },
          {
            field:"medicalIndv",
            title:"医疗",
          },
          {
            field:"unemploymentIndv",
            title:"失业",
          },
          {
            field:"fundIndv",
            title:"公积金",
          },
          {
            field:"endowmentIndvMonth",
            title:"养老保险扣款月次（个人）",
          }
        ],
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          batchId:this.$route.query.batchId,
          taxType:this.$route.query.taxType

        }
      }
    },
    methods:{
      _getEmpWagesList(){
        getEmpWagesList(this.listQuery).then(res => {
          console.log(res);
          this.listQuery.total = res.data.total
          this.list = res.data.records
        } ).catch((error) => {
          console.log("错误信息"+error)
        })
      },
      backToCodeSet(){
        this.$router.go(-1)
      },
    }

  }
</script>

